module.exports = __webpack_public_path__ + "img/20191230155910996.0bac4729.jpg";